import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const uploadHomepageBanner = async (formData) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  try {
    const response = await fetch(`${API_URL}/admin/homepage-banners`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
      body: formData,
    });

    const data = await response.json();
    if (data.session) {
      handleSessionExpire();
      return;
    }

    return data;
  } catch (error) {
    console.error('Homepage banner upload failed:', error);
    throw error;
  }
};

const fetchHomepageBanners = async () => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  try {
    const response = await fetch(`${API_URL}/admin/homepage-banners`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });

    const data = await response.json();
    return data.session ? handleSessionExpire() : data;
  } catch {
    return false;
  }
};

const updateHomepageBanner = async (id, payload) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin/homepage-banners/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  return data.session ? handleSessionExpire() : data;
};

const deleteHomepageBanner = async (id) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin/homepage-banners/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
  });

  const data = await response.json();
  return data.session ? handleSessionExpire() : data;
};

export {
  uploadHomepageBanner,
  fetchHomepageBanners,
  updateHomepageBanner,
  deleteHomepageBanner,
};
